import cookie from 'cookie';
import { Exposure, ExposureTrackingProvider } from '@amplitude/experiment-js-client';
import { v4 as uuidv4 } from 'uuid';

export { Experiment } from '@amplitude/experiment-js-client';

export const UUID = 'uuid';

export const createGtmExposureTracker = (dataLayer: any): ExposureTrackingProvider => ({
  track: (exposure: Exposure) => {
    dataLayer.push({ event: 'LogEvent', eventType: '$exposure', eventProperties: exposure });
  },
});

// Deletes a legacy cookie left from backend that could potentially get picked up by Amplitude SDK
// and mess with the new cookie which has the proper deviceId
export const deleteAmplitudeLegacyCookie = (cookieName: string) => {
  const cookies = cookie.parse(document.cookie);

  if (cookies[cookieName]) {
    document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  }
};

// Get Amplitude Analytics deviceId, if set from rails backend. This is very important in a web context,
// to make Analytics events and Experiment assignments stick together into a single user journey
export const getDeviceIdFromAmplitudeCookie = (apiKey: string) => {
  const cookies = cookie.parse(document.cookie);
  const amplitudeCookie = cookies[`AMP_${apiKey.substring(0, 10)}`];

  try {
    return JSON.parse(decodeURIComponent(atob(amplitudeCookie))).deviceId;
  } catch (error) {
    return undefined;
  }
};

export const getDeviceIdFromLocalStorage = async () => {
  let storedUuid = await localStorage.getItem(UUID);

  if (!storedUuid) {
    storedUuid = uuidv4();

    await localStorage.setItem(UUID, storedUuid);
  }

  return storedUuid;
};
